import createClient from 'openapi-fetch';
import { localizedFetch } from '@/lib/apiClient';
import { getPersianErrorMessage } from '@/lib/persianUi';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
    fetch: localizedFetch,
});

export async function getMyWallet() {
    const { data, error } = await client.GET('/customer/referral/wallet');
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت کیف پول.'));
    }
    return data;
}

export async function getMyCommissions() {
    const { data, error } = await client.GET('/customer/referral/commissions');
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت پورسانت‌ها.'));
    }
    return data || [];
}

export async function getMyReferralLink() {
    const { data, error } = await client.GET('/customer/referral/link');
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت لینک معرف.'));
    }
    return data;
}

export async function getMyReferralStats() {
    const { data, error } = await client.GET('/customer/referral/stats');
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت آمار معرفی.'));
    }
    return data;
}

export async function getMyReferralTree(maxDepth = 3) {
    const { data, error } = await client.GET(
        `/customer/referral/tree?max_depth=${maxDepth}`
    );
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت درخت معرفی.'));
    }
    return data;
}